exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2780131e] .el-card__body{height:100%}.successTextColor[data-v-2780131e]{color:var(--tagSuccessText)}.infoText[data-v-2780131e]{color:var(--tagInfoText)}", ""]);

// exports
